<template>
  <div class="password-change-fieldset-parts">
    <label>
      <span class="label-text">{{ $t('formParts.label.oldPassword') }}</span>
    </label>
    <password-with-toggle-button
      :placeholder="$t('formParts.placeholder.password')"
      v-model="inputPassword.old"
      :error="showOldPasswordError"
      @enter="emitEnter"
    />
    <form-error-message-parts
      :showError="showOldPasswordError"
      :message="oldPasswordErrorMessage"
    />

    <label>
      <span class="label-text">{{ $t('formParts.label.newPassword') }}</span>
    </label>
    <password-with-toggle-button
      :placeholder="$t('formParts.placeholder.password')"
      v-model="inputPassword.new"
      :error="showNewPasswordError"
      @enter="emitEnter"
    />
    <form-error-message-parts
      :showError="showNewPasswordError"
      :message="newPasswordErrorMessage"
    />

    <label>
      <span class="label-text">{{ $t('formParts.label.newPasswordReEnter') }}</span>
    </label>
    <password-with-toggle-button
      :placeholder="$t('formParts.placeholder.password')"
      v-model="inputPassword.reEnter"
      :error="showNewPasswordReEnterError"
      @enter="emitEnter"
    />
    <form-error-message-parts
      :showError="showNewPasswordReEnterError"
      :message="newPasswordReEnterErrorMessage"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from '@vue/composition-api'
import PasswordWithToggleButton from '@/components/common/form/PasswordWithToggleButtonParts.vue'
import FormErrorMessageParts from '@/components/common/form/FormErrorMessageParts.vue'

/**
 * マイページ: 会員情報変更 パスワード変更入力フィールドセットパーツ
 */
export default defineComponent({
  name: 'FieldsetPasswordChangeParts',
  components: {
    PasswordWithToggleButton,
    FormErrorMessageParts,
  },
  props: {
    /**
     * パスワード
     * { old: string, new: string, reEnter: string  }
     */
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    /**
     * 現在のパスワード エラーフラグ
     */
    showOldPasswordError: {
      type: Boolean,
      default: false,
    },
    /**
     * 新しいパスワード エラー表示フラグ
     */
    showNewPasswordError: {
      type: Boolean,
      default: false,
    },
    /**
     * 新しいパスワード(確認用) エラー表示フラグ
     */
    showNewPasswordReEnterError: {
      type: Boolean,
      default: false,
    },
    /**
     * 現在のパスワード エラーメッセージ
     */
    oldPasswordErrorMessage: {
      type: String,
      default: '',
    },
    /**
     * 新しいパスワード エラーメッセージ
     */
    newPasswordErrorMessage: {
      type: String,
      default: '',
    },
    /**
     * 新しいパスワード(確認用) エラーメッセージ
     */
    newPasswordReEnterErrorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    /**
     * password
     * @param {string} val パスワード
     */
    const inputPassword = computed({
      get: () => props.value, // eslint-disable-next-line
      set: (val: any) => context.emit('update:value', val),
    })

    return {
      inputPassword,
    }
  },
  methods: {
    /**
     * Enter Push
     */
    emitEnter(): void {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
    /**
     * Enter Push
     */
    changePassword(): void {
      /**
       * Enterボタン押下を通知する
       * @event login
       * @type {Object}
       */
      this.$emit('enter')
    },
  },
})
</script>

<style lang="scss" scoped>
.password-change-fieldset-parts {
  @include fieldSet();

  > label {
    &:not(:first-child) {
      margin-top: 24px;
    }
  }
}
</style>
